import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../store';
import { clearLoginPendingConfirmation } from '../../store/auth/authActions';
import LoginModal from '../Components/Modals/Login/LoginModal';
import SessionConfirmationModal from '../Components/Modals/Login/SessionConfirmationModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Login'>;

const LoginScreen: React.FC<Props> = ({ navigation }) => {
	const dispatch = useDispatch();
	const [data, setData] = useState({
		username: '',
		password: '',
	});
	const [errors, setErrors] = useState<{
		username?: string;
		password?: string;
	}>({});

	const pendingConfirmation = useSelector((s: RootState) => s.auth.pendingConfirmation);

	const isInitialMount = useRef(true);

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
			dispatch(clearLoginPendingConfirmation());
		}
	}, [dispatch]);

	const onChange = (name: keyof typeof data, value: string) =>
		setData(d => ({ ...d, [name]: value }));

	return (
		<>
			<LoginModal
				onClose={() => navigation.goBack()}
				data={data}
				errors={errors}
				onChange={onChange}
				setErrors={setErrors}
			/>
			{pendingConfirmation && (
				<SessionConfirmationModal
					visible
					onClose={() => {}}
					pendingConfirmation={pendingConfirmation}
				/>
			)}
		</>
	);
};

export default LoginScreen;
